<template>
  <div :class="styleToMe ? 'self' : ''" style="display: flex; align-items: center; flex-direction: row">
    <div v-if="data.type === 'TEXT'" class="text">
      <p v-html="$options.filters.formatTxt(data.info.msg)" />
    </div>

    <img
      v-else-if="data.type === 'IMAGE'"
      :src="data.info.url"
      style="max-width: 180px; border-radius: 8px"
      @click="
        $photoswipe.open([
          {
            src: data.info.url,
            w: 1000,
            h: 500,
          },
        ])
      "
    />

    <VoiceBar v-else-if="data.type === 'VOICE'" :src="data.info.url" :is-me="styleToMe" />

    <div v-if="data.type === 'FILE'" class="file" @click="downloadFile(data.info.url, data.info.filename)">
      <div class="fileInfoBox">
        <div class="fileNameBox" :title="data.info.filename || '未知文件'">
          {{ data.info.filename || '未知文件' }}
        </div>
        <span class="fileSize">{{ $options.filters.getfilesize(data.info.file_length) }}</span>
      </div>
      <div class="fileImgBox">
        <a-icon
          :type="$options.filters.getIconToFileName(data.info.filename)"
          style="font-size: 40px; color: #b8b8b8"
        />
      </div>
    </div>

    <video v-else-if="data.type === 'VIDEO'" :src="data.info.url" controls width="230px" />

    <a
      v-else-if="data.type === 'LOCATION'"
      target="_blank"
      :href="`https://uri.amap.com/marker?position=${data.info.lng},${data.info.lat}&name=${data.info.addr}&src=hw&coordinate=gaode&callnative=0`"
    >
      <img
        style="width: 300px; height: 150px"
        :src="`https://restapi.amap.com/v3/staticmap?location=${data.info.lng},${data.info.lat}&zoom=17&scale=2&size=300*150&markers=mid,,A:${data.info.lng},${data.info.lat}&key=243d122fb21dea62fc67581e7c852fec`"
      />
    </a>
  </div>
</template>

<script>
// 消息解析
import { getfilesize, getIconToFileName, downloadWithBlob } from '@/utils/files'
import emoji from '~/const/emoji'
import VoiceBar from '~/components/chat/components/msgItem/VoiceBar'

export default {
  name: 'MessageParsing',
  components: {
    VoiceBar,
  },
  filters: {
    getfilesize,
    getIconToFileName,
    // 识别文本中的超链接, 并转义
    formatTxt(txt = '') {
      const rnTxt = []
      let match = null
      const regex = /(\[.*?\])/g
      let start = 0
      let index = 0
      while ((match = regex.exec(txt))) {
        index = match.index
        if (index > start) {
          rnTxt.push(txt.substring(start, index))
        }
        if (match[1] in emoji.obj) {
          const v = emoji.obj[match[1]]
          rnTxt.push(this.customEmoji(v))
        } else {
          rnTxt.push(match[1])
        }
        start = index + match[1].length
      }
      rnTxt.push(txt.substring(start, txt.length))
      return rnTxt.toString().replace(/,/g, '')
    },
    customEmoji(value) {
      return `<img src="https://oss-resource668.yzdli.com/website/image/faces/${value}" style="width:30px"/>`
    },
  },
  props: [
    // type 消息类型 TEXT VIDEO IMAGE FILE VOICE LOCATION
    // info 格式见下方
    // 传入数据
    'data',
    // 是否显示由我发送样式
    'styleToMe',
    // 各类型消息所需属性
    /*
    info
    TEXT
    msg
    "[{\"msg\": \"绕弯儿而为v\", \"type\": \"txt\"}]"

    VIDEO
    url
    "[{\"url\": \"http://a1-v2.easemob.com/1115200522168856/yunexhibitionapp/chatfiles/1e33b3e0-87b4-11eb-836e-adc8883eda8b\", \"type\": \"video\", \"length\": 0, \"secret\": \"HjPa8Ie0EeuXiZGlpt0ig-Un7Vtscq8zlCsYp5hoqoQiWlfe\", \"filename\": \"ENLAYFCUUAI8th3.mp4\", \"file_length\": 0, \"thumbFilename\": \"ENLAYFCUUAI8th3.mp4\"}]"

    IMAGE
    url
    "[{\"url\": \"http://a1-v2.easemob.com/1115200522168856/yunexhibitionapp/chatfiles/22b0d790-87b4-11eb-bfa3-4ffffe3e6310\", \"size\": {\"width\": 0, \"height\": 0}, \"type\": \"img\", \"secret\": \"IrD-oIe0EeugDUW48fEXRqwRb1MD1kyCqC9OkzY1jEGAstoq\", \"filename\": \"椭圆 4 拷贝@2x.png\", \"file_length\": 0, \"thumbFilename\": \"椭圆 4 拷贝@2x.png\"}]"

    FILE
    url filename file_length
    "[{\"url\": \"http://a1-v2.easemob.com/1115200522168856/yunexhibitionapp/chatfiles/267a3ba0-87b4-11eb-abaa-6b16e0476866\", \"size\": {\"width\": 0, \"height\": 0}, \"type\": \"file\", \"secret\": \"JnpisIe0Eeu-j8ES0WOK2YJMTMYfqjksbv7J0Fb4mO8tXP8u\", \"filename\": \"椭圆 4 拷贝@2x.zip\", \"file_length\": 0, \"thumbFilename\": \"椭圆 4 拷贝@2x.zip\"}]"

    VOICE
    url

    LOCATION
    lng lat addr

    */
  ],
  beforeDestroy() {
    this.$photoswipe.close()
  },
  methods: {
    downloadFile(url, name) {
      downloadWithBlob(url, name)
    },
  },
}
</script>

<style lang="scss" scoped>
.text {
  min-height: 30px;
  max-width: 340px;
  font-size: 14px;
  text-align: left;
  word-break: break-all;
  background: #fff;
  border-radius: 0 8px 8px 8px;
  line-height: 1.4;
  border: 1px solid #f1f1f1;
  p {
    padding: 4px 10px;
    font-size: 16px;
    margin: 0;
  }
}

.file {
  width: 230px;
  height: 80px;
  border-radius: 6px;
  background-color: white;
  border: 1px solid #f1f1f1;
  box-sizing: border-box;
  display: flex;
  & > div {
    height: 100%;
  }
  .fileInfoBox {
    flex: 1;
    padding: 10px;
    padding-right: 0;
    overflow: hidden;
    .fileNameBox {
      font-weight: 500;
      color: black;
      width: 100%;
      max-height: 40px;
      overflow: hidden;

      /*将对象作为弹性伸缩盒子模型显示*/
      display: -webkit-box;
      /*设置子元素排列方式*/
      -webkit-box-orient: vertical;
      /*设置显示的行数,多出的部分会显示为...*/
      -webkit-line-clamp: 2;
    }
    .fileSize {
      font-size: 12px;
    }
  }
  .fileImgBox {
    width: 70px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &:hover {
    background-color: #fdfdfd;
    cursor: pointer;
  }
}

.self {
  flex-direction: row-reverse;
  .messageOperatIconBox {
    order: 0;
    margin-right: 10px;
    margin-left: 0;
  }
  .text {
    color: #fff;
    background: rgba(234, 67, 53, 0.9);
    border-radius: 8px 0 8px 8px;
    border: none;
  }
  img {
    margin-right: 0px;
    margin-left: 10px;
  }
  .voice {
    color: #fff;
    background: rgba(234, 67, 53, 0.9);
    border-radius: 8px 0 8px 8px;
  }
}
</style>
